
export default function WhyMe() {
  const reasons = [
    {
      icon: 'ri-briefcase-line',
      title: 'Je parle business, pas jargon tech',
      description:
        'Avant de parler outils, je comprends votre mod\u00e8le \u00e9conomique, vos marges et vos objectifs. Chaque action est li\u00e9e \u00e0 un r\u00e9sultat mesurable.',
    },
    {
      icon: 'ri-hand-coin-line',
      title: 'J\u2019ai g\u00e9r\u00e9 des P&L',
      description:
        'Avoir pilot\u00e9 des budgets et des \u00e9quipes me donne une vision pragmatique. Je sais ce que co\u00fbte un lead et ce qu\u2019il doit rapporter.',
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Strat\u00e9gie + Ex\u00e9cution',
      description:
        'Je ne me contente pas de recommandations PowerPoint. Je mets en place, je mesure, j\u2019optimise. Vous avez un seul interlocuteur de A \u00e0 Z.',
    },
    {
      icon: 'ri-shield-star-line',
      title: '20 ans de terrain',
      description:
        'Retail, services, tech, e-commerce\u2026 J\u2019ai travaill\u00e9 avec des entreprises de toutes tailles et dans de nombreux secteurs. Rien ne me surprend.',
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Passion du r\u00e9sultat',
      description:
        'Votre succ\u00e8s est mon succ\u00e8s. Je m\u2019investis personnellement dans chaque projet parce que je crois en ce que je fais.',
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Veille permanente',
      description:
        'Le digital \u00e9volue vite. Je teste en continu les nouveaux leviers (IA, automatisation, nouveaux canaux) pour vous donner un avantage comp\u00e9titif.',
    },
  ];

  return (
    <section className="py-16 sm:py-24 bg-gray-50 overflow-hidden">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <header className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Pourquoi me faire <strong className="text-orange-600">confiance</strong> ?
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Ce qui fait la diff\u00e9rence quand vous travaillez avec moi
          </p>
        </header>

        {/* Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasons.map((r, i) => (
            <article
              key={i}
              className="group bg-white rounded-2xl p-6 sm:p-7 shadow-md border border-gray-100 hover:border-orange-200 hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
            >
              <div className="w-11 h-11 rounded-lg bg-orange-50 flex items-center justify-center mb-4 group-hover:bg-gradient-to-br group-hover:from-orange-500 group-hover:to-orange-600 transition-all duration-300">
                <i
                  className={`${r.icon} text-xl text-orange-600 group-hover:text-white transition-colors duration-300`}
                />
              </div>
              <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2">
                {r.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {r.description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
